(function () {
  var section = document.querySelector('.wholesale-account-page.ws');
  if (!section) return;

  var items = Array.prototype.slice.call(section.querySelectorAll('[data-reveal]'));
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var element = entry.target;
          var perks = section.querySelectorAll('.ws__perk');
          var delay = element.classList.contains('ws__perk')
            ? Array.prototype.indexOf.call(perks, element) * 110
            : 0;
          window.setTimeout(function () { element.classList.add('is-visible'); }, delay);
          observer.unobserve(element);
        }
      });
    }, { threshold: 0.12 });
    items.forEach(function (element) { io.observe(element); });
  } else {
    items.forEach(function (element) { element.classList.add('is-visible'); });
  }

  var whatsappButton = section.querySelector('[data-whatsapp-prefill]');

  function configureWhatsapp() {
    var storeWhatsappButton = document.querySelector('#waFloatBtn');
    if (!whatsappButton || !storeWhatsappButton || !storeWhatsappButton.href) return;

    var whatsappUrl = new URL(storeWhatsappButton.href, window.location.href);
    whatsappUrl.searchParams.set('text', "Hi Zist Zari, I'm interested in a wholesale account.");
    whatsappButton.href = whatsappUrl.toString();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', configureWhatsapp);
  } else {
    configureWhatsapp();
  }

})();
